import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { logout } from '@/services/auth.jsx';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => logout(),
    onSettled: () => {
      // Clear any cached user/auth state so the app treats the user as logged out
      queryClient.removeQueries({ queryKey: ['auth'], exact: false });
      // Redirect to the public entry (login page lives at '/')
      navigate('/', { replace: true });
    },
  });
}
